import { makeStyles, Theme } from '@material-ui/core'

const useStyles = makeStyles<Theme, { isSelected: boolean }>((theme) => ({
  root: {
    border: `1px solid ${theme.palette.secondary.light}`,
    borderRadius: '8px',
    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.12), 0px 0px 0px 1px rgba(19, 45, 74, 0.04)',
  },
  title: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(2),
    '&:hover': {
      background: ({ isSelected = false }) =>
        isSelected ? theme.palette.primary.light : 'inherit',
    },
    background: ({ isSelected = false }) => (isSelected ? theme.palette.primary.light : 'inherit'),
  },
  content: {
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(3),
    },
  },
  button: {
    padding: 0,
    '&:hover': {
      background: 'transparent',
    },
  },
  item: {
    [theme.breakpoints.up('sm')]: {
      paddingLeft: ({ isSelected = false }) => (isSelected ? theme.spacing(1.25) : 'inherit'),
    },
  },
}))

export default useStyles
